import { RouteWrapperVariant } from "../../../../constants/layouts/route-wrapper-variant.enum";
import type { IRouteWrapperVariant } from "../../../../types/layout/route-wrapper-variant.interface";
import { FirstLevelRouteWrapperVariant } from "./first-level/first-level-route-wrapper-variant";
import { FullScreenRouteWrapperVariant } from "./full-screen-route/full-screen-route-wrapper-variant";
import { FullScreenWithCloseButtonRouteWrapperVariant } from "./full-screen-with-close-button/full-screen-with-close-button-route-wrapper-variant";
import { FullScreenWithHeaderAndCloseModalRouteWrapperVariant } from "./full-screen-with-header-and-close-modal/full-screen-with-header-and-close-modal-route-wrapper-variant";
import { FullScreenWithHeaderAndCloseRouteWrapperVariant } from "./full-screen-with-header-and-close/full-screen-with-header-and-close-route-wrapper-variant";
import { PracticeDetailRouteWrapperVariant } from "./practice-detail/practice-detail-route-wrapper-variant";
import { ProductDetailRouteWrapperVariant } from "./product-detail/product-detail-route-wrapper-variant";
import { ProfileDataRouteWrapperVariant } from "./profile-data/profile-data-route-wrapper-variant";
import { ProfileRouteWrapperVariant } from "./profile/profile-route-wrapper-variant";
import { SecondLevelWithTitleAndAiAssistantFullHeightRouteWrapperVariant } from "./second-level-with-ai-assistant-fullheight/second-level-with-ai-assistant-fullheight-route-wrapper-variant";
import { SecondLevelWithTitleAndAiAssistantRouteWrapperVariant } from "./second-level-with-ai-assistant/second-level-with-ai-assistant-route-wrapper-variant";
import { UnauthenticatedRouteWithBackButtonVariant } from "./unauthenticated-route-with-back-button/unauthenticated-route-with-back-button-variant";
import { UnauthenticatedRouteVariant } from "./unauthenticated-route/unauthenticated-route-variant";
import { UpgradePageRouteWrapperVariant } from "./upgrade-page/upgrade-page-route-wrapper-variant";

abstract class IRouteWrapperVariantFactory {
  abstract createRouteWrapperVariant(variant: RouteWrapperVariant): IRouteWrapperVariant;
}

export class RouteWrapperVariantFactory implements IRouteWrapperVariantFactory {
  createRouteWrapperVariant(variant: RouteWrapperVariant): IRouteWrapperVariant {
    switch (variant) {
      case RouteWrapperVariant.firstLevel:
        return new FirstLevelRouteWrapperVariant();

      case RouteWrapperVariant.unauthenticatedRoute:
        return new UnauthenticatedRouteVariant();

      case RouteWrapperVariant.unauthenticatedRouteWithBackButton:
        return new UnauthenticatedRouteWithBackButtonVariant();

      case RouteWrapperVariant.productDetail:
        return new ProductDetailRouteWrapperVariant();

      case RouteWrapperVariant.practiceDetail:
        return new PracticeDetailRouteWrapperVariant();

      case RouteWrapperVariant.fullScreen:
        return new FullScreenRouteWrapperVariant();

      case RouteWrapperVariant.secondLevelWithTitleAndAiAssistant:
        return new SecondLevelWithTitleAndAiAssistantRouteWrapperVariant();

      case RouteWrapperVariant.secondLevelWithTitleAndAiAssistantFullHeight:
        return new SecondLevelWithTitleAndAiAssistantFullHeightRouteWrapperVariant();

      case RouteWrapperVariant.fullScreenWithHeaderAndCloseButton:
        return new FullScreenWithHeaderAndCloseRouteWrapperVariant();

      case RouteWrapperVariant.fullScreenWithHeaderAndCloseModal:
        return new FullScreenWithHeaderAndCloseModalRouteWrapperVariant();

      case RouteWrapperVariant.upgradePage:
        return new UpgradePageRouteWrapperVariant();

      case RouteWrapperVariant.profileData:
        return new ProfileDataRouteWrapperVariant();

      case RouteWrapperVariant.profile:
        return new ProfileRouteWrapperVariant();

      case RouteWrapperVariant.fullScreenWithCloseButton:
        return new FullScreenWithCloseButtonRouteWrapperVariant();
    }
  }
}
